<template>
  <div id="app">
    <header>
      <b-navbar
        toggleable="lg"
        type="dark"
        variant="dark"
      >
        <b-navbar-brand
          href="#"
          class="ml-5"
        >
          <b-img
            :src="'./logo/nku0.png'"
            fluid
            class="nku-logo"
          />
          <div class="d-inline-block border-left v-line align-middle mx-3" />
          <b-img
            :src="'./logo/ntu0.png'"
            fluid
            class="ntu-logo mr-4"
          />
          <div class="d-inline-block align-middle text-left">
            Lighting the Darkness in the Deep Learning Era
          </div>
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto mr-5">
          <b-button
            class="my-0"
            variant="outline-light"
            v-b-modal.modal-select
          >
            Select / Upload
          </b-button>
        </b-navbar-nav>
      </b-navbar>
    </header>
    <b-modal
      id="modal-select"
      title="Select / Upload"
      size="xl"
      @close="onModalClose"
      hide-footer
    >
      <h5 class="font-weight-light">
        Upload an image
      </h5>
      <div
        class="file-box m-3"
        @click="onFileClick"
      >
        <b-form-file
          v-model="file"
          accept="image/jpeg,image/png"
          placeholder="Click to upload or drag here..."
          drop-placeholder="Drop here..."
          :disabled="uploading"
          @input="onFileChange"
        />
        <b-progress
          class="mt-3"
          variant="secondary"
          height="2rem"
          :max="progressMax"
          animated
          v-if="uploading"
        >
          <b-progress-bar
            :value="progressValue"
          >
            <span class="progress-text">
              {{ progressText }}
            </span>
          </b-progress-bar>
        </b-progress>
      </div>
      <div class="my-4 border-bottom" />
      <h5 class="font-weight-lighter">
        Select one from examples
      </h5>
      <b-card-group
        columns
        class="p-3"
      >
        <b-card
          class="text-center shadow-sm text-muted"
          :class="{'sample-card': !uploading}"
          no-body
          img-top
          @click="selectImg(index)"
          v-for="(name, index) in samples"
          :key="index"
          :img-src="'./images/Input/' + name"
          footer-tag="footer"
        >
          <template #footer>
            {{ name }}
          </template>
        </b-card>
      </b-card-group>
    </b-modal>
    <main>
      <div class="home py-3 bg-light">
        <b-container>
          <b-row
            cols="3"
            no-gutters
          >
            <b-col
              v-for="(method, index) in methods"
              :key="index"
              class="p-2"
            >
              <b-card
                class="text-center shadow-sm text-muted"
                no-body
                img-top
                footer-tag="footer"
              >
                <b-overlay
                  :show="loading[index]"
                >
                  <b-card-img
                    :src="
                      isDemo
                        ? './images/' + method.name + '/' + imgName
                        : backendURL + '/upload/source/' + imgName + '/'
                          + (loading[index] ? methods[0].result : method.result)
                    "
                    alt="Image"
                  />
                </b-overlay>
                <template #footer>
                  {{ method.name }}
                  <sup>
                    {{ index === 0 ? "" : " [" + index + "]" }}
                  </sup>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </main>
    <footer class="text-muted py-3">
      <div class="container text-left">
        <h5>References</h5>
        <div style="font-size: 0.8rem">
          <div
            class="d-flex flex-row"
            v-for="(method, index) in methods.slice(1)"
            :key="index"
          >
            <div class="mr-2">
              [{{ index + 1 }}]
            </div>
            <div>{{ method.ref }}</div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// import Home from './components/Home.vue';
import samples from './samples.js';
import methods from './methods.js';
export default {
  name: 'App',
  // components: {
  //   Home,
  // },
  data: function() {
    return {
      isDemo: true,
      imgName: '',
      select: 0,
      file: [],
      samples,
      methods,
      uploading: false,
      progressValue: 0,
      progressMax: 0,
      progressText: '',
      loading: null,
      responseList: [],
    };
  },
  created: function() {
    this.imgName = this.samples[this.select];
    this.progressMax = 3;
    // this.progressMax = this.methods.length + 1;
    this.loading = Array.from(this.methods, (_, i) => { return false; });
  },
  methods: {
    selectImg(idx) {
      if (!this.uploading) {
        this.isDemo = true;
        this.select = idx;
        this.imgName = this.samples[this.select];
        this.$bvModal.hide('modal-select');
      }
    },
    async onFileChange() {
      console.log(this.file);
      if (this.file !== []) {
        // console.log(e);
        // console.log(this.file);
        this.progressValue = 1;
        this.progressText = 'Uploading...';
        this.uploading = true;
        const param = new window.FormData();
        param.append('file', this.file);
        const config = {
          headers: { 'Content-Type': 'multipart/form-data' },
        };
        this.progressValue += 1;
        const uploadResponse = await this.axios
          .post(this.backendURL + '/2/upload/', param, config);
          // .catch((error) => { console.log('catch', error); });
        console.log('uploadResponse', uploadResponse);
        this.progressValue += 1;
        this.isDemo = false;
        this.imgName = uploadResponse.data.filename;
        this.progressText = 'Processing...';
        const filename = this.imgName;
        const timeout = 120000;
        for (let index = 1; index < this.methods.length; index++) {
          // for (const method of this.methods.slice(1)) {
          this.loading[index] = true;
        }

        // const responseList = await Promise.all(requestList);
        // console.log('responseList', responseList);
        const earlyMethodList = ['RRDNet', 'ExCNet', 'LLNet', 'LightenNet'];
        // const earlyMethodList = ['RRDNet', 'ExCNet'];
        const requestList = [];
        for (let index = 1; index < this.methods.length; index++) {
          for (const delayMethodName of earlyMethodList) {
            if (this.methods[index].name === delayMethodName) {
              requestList.push(
                this.axios
                  .post(this.backendURL + '/' + this.methods[index].api + '/', {filename}, {timeout})
                  .then((response) => {
                    this.progressValue += 1;
                    this.loading.splice(index, 1, false);
                    return response;
                  })
                  .catch((error) => {
                    console.log(error);
                    return error;
                  }),
              );
            }
          }
        }
        for (let index = 1; index < this.methods.length; index++) {
          if (earlyMethodList.indexOf(this.methods[index].name) !== -1) {
            continue;
          }
          requestList.push(
            this.axios
              .post(this.backendURL + '/' + this.methods[index].api + '/', {filename}, {timeout})
              .then((response) => {
                this.progressValue += 1;
                this.loading.splice(index, 1, false);
                return response;
              })
              .catch((error) => {
                console.log(error);
                return error;
              }),
          );
          // );
        }
        this.uploading = false;
        this.$nextTick(() => {
          this.$bvModal.hide('modal-select');
          console.log('after hide');
        });
        // this.$nextTick(async() => {
        // setTimeout(async() => {
        this.responseList = await Promise.all(requestList);
        // }, 1000);
        // });
      }
    },
    onFileClick() {
      // this.file = [];
      console.log(this.file);
      console.log('click');
    },
    onModalClose(bvModalEvt) {
      if (this.uploading) {
        bvModalEvt.preventDefault();
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.card-footer {
  padding: 0.5rem 1rem;
}
.nku-logo {
  max-height: 64px;
}
.ntu-logo {
  max-height: 64px;
}
.v-line {
  height: 56px;
}
div {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.sample-card {
  cursor: pointer;
}
.progress-text {
  font-size: 16px;
  /* font-weight: lighter; */
}
</style>
